export enum NgxMatTimepickerMeasure {
    hour = "hour",
    minute = "minute"
}
